<template>
  <Layout>
    <PageHeader :title="title" />

    <!-- Upload Section -->
    <b-row class="mb-4">
      <!-- Swiggy Ads Burn -->
      <b-col md="6" class="mb-3">
        <b-card variant="info" header="Swiggy Ads Burn">
          <b-form-group label="Select Date Range">
            <date-picker
              range
              v-model="swiggyDateRange"
              :unlink-panels="true"
              format="YYYY-MM-DD"
            ></date-picker>
          </b-form-group>

          <b-form-group label="Choose File">
            <chunk-upload @uploadcomplete="onSwiggyUploadComplete" />
          </b-form-group>

          <b-button
            variant="light"
            :disabled="!canUploadSwiggy"
            @click="upload('swiggy')"
          >
            Upload
          </b-button>
        </b-card>
      </b-col>

      <!-- Zomato Ads Burn -->
      <b-col md="6" class="mb-3">
        <b-card variant="warning" header="Zomato Ads Burn">
          <b-form-group label="Select Date Range">
            <date-picker
              range
              v-model="zomatoDateRange"
              :unlink-panels="true"
              format="YYYY-MM-DD"
            ></date-picker>
          </b-form-group>

          <b-form-group label="Choose File">
            <chunk-upload @uploadcomplete="onZomatoUploadComplete" />
          </b-form-group>

          <b-button
            variant="light"
            :disabled="!canUploadZomato"
            @click="upload('zomato')"
          >
            Upload
          </b-button>
        </b-card>
      </b-col>
    </b-row>

    <!-- Pending Uploads Table -->
    <b-card>
      <b-card-body>
        <b-table :items="uploads" :fields="fields" responsive="sm" small>
          <template #cell(created_at)="data">
            {{ formatDate(data.item.created_at) }}
          </template>

          <template #cell(date_range)="data">
            {{ formatDate(data.item.start_date) }}
            &nbsp;→&nbsp;
            {{ formatDate(data.item.end_date) }}
          </template>
        </b-table>
      </b-card-body>
      <b-card-footer class="d-flex justify-content-end">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalUploads"
          :per-page="perPage"
          align="right"
        ></b-pagination>
      </b-card-footer>
    </b-card>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import DatePicker from "vue2-datepicker";
import ChunkUpload from "../utils/ChunkUpload.vue";
import axios from "axios";
import moment from "moment";
import { ADS_BURN_PATH } from "../../../../path";

export default {
  components: {
    Layout,
    PageHeader,
    DatePicker,
    ChunkUpload,
  },
  data() {
    return {
      title: "Ads Burn Uploads",
      // Upload state
      swiggyDateRange: [null, null],
      zomatoDateRange: [null, null],
      swiggyFile: null,
      zomatoFile: null,
      // Table state
      uploads: [],
      fields: [
        { key: "file_type", label: "File Type" },
        { key: "file_name", label: "File Name" },
        { key: "status", label: "Status" },
        { key: "created_at", label: "Created At" },
        // { key: "week_no", label: "Week No." },
        { key: "date_range", label: "Date Range" },
      ],
      currentPage: 1,
      perPage: 10,
      totalUploads: 0,
      base_node_url: process.env.VUE_APP_API_BACKEND_NODE_URL,
    };
  },
  computed: {
    canUploadSwiggy() {
      return (
        this.swiggyFile && this.swiggyDateRange[0] && this.swiggyDateRange[1]
      );
    },
    canUploadZomato() {
      return (
        this.zomatoFile && this.zomatoDateRange[0] && this.zomatoDateRange[1]
      );
    },
  },
  mounted() {
    this.fetchUploads();
  },
  methods: {
    // Handlers for ChunkUpload component
    onSwiggyUploadComplete(filename) {
      this.swiggyFile = filename;
      console.log(filename, "swiggy");
    },
    onZomatoUploadComplete(filename) {
      this.zomatoFile = filename;
    },

    // Perform the upload POST
    async upload(provider) {
      const isSwiggy = provider === "swiggy";
      const fileName = isSwiggy ? this.swiggyFile : this.zomatoFile;
      const [start, end] = isSwiggy
        ? this.swiggyDateRange
        : this.zomatoDateRange;

      if (!fileName || !start || !end) return;

      try {
        await axios.post(this.base_node_url + ADS_BURN_PATH.ADS_REPORT, {
          file_type: provider,
          file_name: fileName,
          start_date: moment(start).format("YYYY-MM-DD"),
          end_date: moment(end).format("YYYY-MM-DD"),
        });
        // Clear inputs
        if (isSwiggy) {
          this.swiggyFile = null;
          this.swiggyDateRange = [null, null];
        } else {
          this.zomatoFile = null;
          this.zomatoDateRange = [null, null];
        }
        this.fetchUploads();
      } catch (err) {
        console.error("Upload failed:", err);
      }
    },

    // Fetch list of uploads
    async fetchUploads() {
      try {
        const res = await axios.get(
          this.base_node_url + ADS_BURN_PATH.ADS_REPORT,
          {
            params: {
              page: this.currentPage,
              per_page: this.perPage,
            },
          }
        );
        // Expect response: { data: { items: [...], total: 42 } }
        this.uploads = res.data.data.items;
        this.totalUploads = res.data.data.total;
      } catch (err) {
        console.error("Failed to load uploads:", err);
      }
    },

    formatDate(dateStr) {
      return moment(dateStr).format("DD-MM-YYYY");
    },
  },
  watch: {
    currentPage() {
      this.fetchUploads();
    },
  },
};
</script>

<style scoped>
.mb-3 {
  margin-bottom: 1rem;
}
</style>
